import * as yup from 'yup';
import { MarketingHeader } from '../MarketingHeader';
import { linkSchema, nullableImageFromCMSSchema } from '../schemas';
import { schema as slideoutMenuLinkSchema } from './slideout_menu_link';
import { schema as slideDownMenuLinkSchema } from './slide_down_menu_link';
import { schema as referAFriendButtonSchema } from './refer_a_friend_button';
import { schema as discountBannerSchema } from './discount_banner';

export const component = MarketingHeader;

export const schema = yup
  .object({
    logoImg: nullableImageFromCMSSchema,
    logoUrl: yup.string().required(),
    logoSrText: yup.string().required(),
    links: yup.array(
      yup.lazy(item => {
        if (item.component === 'slideout_menu_link')
          return slideoutMenuLinkSchema;
        if (item.component === 'slide_down_menu_link')
          return slideDownMenuLinkSchema;
        if (item.component === 'refer_a_friend_button')
          return referAFriendButtonSchema;
        return linkSchema;
      }),
    ),
    discountBannerProps: discountBannerSchema,
    bgColor: yup.string(),
    fontColor: yup.string(),
    ctaButton: yup.object().shape({
      mobileCTAText: yup.string(),
      desktopCTAText: yup.string(),
      ctaTarget: yup.string(),
      ctaVariant: yup.string(),
      testName: yup.string().nullable(),
    }),
  })
  .transform(value => {
    return {
      logoImg: value.logoImg || null,
      logoUrl: value.logo_target.url,
      logoSrText: value.logo_sr_text,
      links: value.left_links || value.navigation_links,
      discountBannerProps: value.discount_banner?.[0],
      ctaButton: {
        mobileCTAText: value.cta_button?.[0]?.mobile_cta_text,
        desktopCTAText: value.cta_button?.[0]?.desktop_cta_text,
        ctaTarget: value.cta_button?.[0]?.cta_target?.url,
        ctaVariant: value.cta_button?.[0]?.cta_variant || undefined,
        testName: value.cta_button?.[0]?.test_name || null,
        component: value.cta_button?.[0]?.component,
        variants: value.cta_button?.[0]?.variants || [],
      },
      bgColor: value.background_color || undefined,
      fontColor: value.font_color || undefined,
    };
  });
